import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api';
import { buildCategoryDisplayCounts } from '../../../shared/categoryHierarchy';

/**
 * Fetches a warehouses `categories_all` endpoint response and returns only
 * categories that currently have matching rows, ready for CategoryFilterBoard.
 * A parent category counts as non-empty when any of its subcategories has rows,
 * even if it has none directly assigned to itself.
 */
export function useCategoryFilterOptions(queryKey, endpoint) {
  const { data } = useQuery({
    queryKey,
    queryFn: () => api.get(endpoint),
    staleTime: 5 * 60 * 1000,
  });
  return useMemo(() => {
    const categories = data?.categories || [];
    const displayCounts = buildCategoryDisplayCounts(categories);
    return categories.filter((c) => (displayCounts.get(c.id) || 0) > 0);
  }, [data]);
}
